/**
 * Reapplies the viewer's topology mode after each model load.
 *
 * The cgt-viewer ships every model as triangles by default. When the loaded
 * model carries quad data (`hasQuadSupport()`), we force quad rendering so
 * quad-generated meshes render the way they were authored. If the viewer
 * rejects the quad switch despite `hasQuadSupport()` returning true
 * (`setTopologyMode` throws when no quad data exists), we fall back to
 * triangle so the viewer never ends up in an inconsistent state across
 * consecutive loads.
 *
 * Called from ViewerContent's load-success handler on every model load.
 */
export function applyTopologyMode(viewer) {
  if (!viewer) {
    return
  }

  if (viewer.hasQuadSupport()) {
    try {
      viewer.setTopologyMode('quad')
    } catch {
      viewer.setTopologyMode('triangle')
    }

    return
  }

  viewer.setTopologyMode('triangle')
}

export default applyTopologyMode
